import Title from "../../../Universal/Title.component";
import "../../../../styles/ComponentsStyles/Setting/Profile/AdvanceInfo.style.css";
import AdvanceInfoCard from "./AdvanceInfoCard.component";
import AppLogo from "../../../../assets/Images/Setting/Profile/AppLogo.png";
import BtnArrow from "../../../../assets/Icons/Universal/ArrowRight.svg"
const AdvanceInfo = () => {
  return (
    <div className="w-full flex-col align-start justify-start g-2 pb-2">
      <div className="w-full flex-col align-start justify-start g-1 radius-10 p-2 back-white">
        <Title>Advance</Title>
        <div className="advanceCardParentContainer pr-3">
          <AdvanceInfoCard
            title="Set up classes with capacity"
            description="You can set the affiliated classes that was filled in previous section."
            path={"setup/classes"}
          />
          <AdvanceInfoCard
            title="Position set with salary slab"
            description="You can set the affiliated classes that was filled in previous section."
            path={"setup/position"}
          />
          <AdvanceInfoCard
            title="Fees section set up"
            description="Set the type of areas in fees; Like sports, rent, medical charges etc."
            path={"setup/fee"}
          />
          <AdvanceInfoCard
            title="Creating teams"
            description="Create any teams to regulate any operations."
            path={"setup/team"}
          />
        </div>
      </div>

      <h3 className="poppins color-grayColor t-16 text-align-center weight-500">
        Here you can access other tools and software of our OMS system. You need
        to buy these software if you want to use. One monthly free trial is
        accessible.
      </h3>
      <div className="w-full flex-row align-center justify-center ">
        <img src={AppLogo} alt="" style={{ height: "8rem" }} />
      </div>
      <div className="w-full flex-row align-center justify-center g-1">
        <p className="poppins t-14 color-black">Visit OMS360 product house</p>
        <button type="button" className="blueActionBtnDark flex-row align-center justify-start g-05   pr-2 pl-2">
          <span>Go to OMS360</span>
          <img src={BtnArrow} alt="" />
        </button>
      </div>
    </div>
  );
};

export default AdvanceInfo;
